import { swalConfirm } from './swal'

export function openInNewWindow(value: string) {
  swalConfirm.fire({ text: '別タブで開きます。よろしいですか？' }).then(result => {
    if (result.isConfirmed) {
      window.open(value)
    }
  })
}
